export const productPreviewOptions: Array<any> = [
  {
    title: 'eCommerce View',
    route: '/ecommerce-view',
    icon: 'eye-icon',
    active: false,
  },
  {
    title: 'Product Details',
    route: '/product-details',
    icon: 'details-icon',
    active: false,
  },
];
